import { render } from "./CalendarEventAttendeeSelectionOverlay.vue?vue&type=template&id=872b416c"
import script from "./CalendarEventAttendeeSelectionOverlay.vue?vue&type=script&lang=ts"
export * from "./CalendarEventAttendeeSelectionOverlay.vue?vue&type=script&lang=ts"
script.render = render

export default script